<!-- 赠送书币操作 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<!-- 标题 -->
		<div class="page-title">追书云书币赠送</div>
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 0;">
			<div class="screen-box">
				<div class="screen-label">注册日期</div>
				<dateRangePicker :date_width="300" :before_number="date_number"
				@onGetDate="onGetDate"></dateRangePicker>
			</div>
			
			
			<!-- <div class="screen-box">
				<div class="screen-label">渠道/书城</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择书城"
					@change="handleChangeA"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					showSearch
					allowClear
				  >
					<a-select-option v-for="(item,index) in filterList.channel_id.list" :key="index" :value="item.key">
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div> -->
			
			<div class="screen-box">
				<div class="screen-label">公众号</div>
				<!-- @popupScroll="popupScrollG" -->
				<a-select
					style="min-width: 200px"
					placeholder="请选择公众号"
					:filter-option="filterOption"
					@change="handleChangeB"
					:getPopupContainer="getsPopupContainer" 
					showSearch
					allowClear
				  >
					<!-- <a-select-option v-for="(item,index) in filterList.gzh_id.list" :key="index" :value="item.key">
					  {{item.value}}
					</a-select-option> -->
					<a-select-option v-for="(item,index) in gzhSelectData" :key="index" :value="item.key">
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">用户ID</div>
				<a-input v-model="r_user_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">Openid</div>
				<a-input v-model="r_openid" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>

			<!-- <div class="screen-box">
				<div class="screen-label">计划ID(单元ID)</div>
				<a-input v-model="r_plan_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">创意ID</div>
				<a-input v-model="r_creative_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div> -->

			<!-- <div class="screen-box">
				<div class="screen-label">是否回传</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeC" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div> -->
			
			<!-- <div class="screen-box">
				<div class="screen-label">媒体平台</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeD" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="toutiao">头条</a-select-option>
					<a-select-option value="baidu">百度</a-select-option>
				</a-select>
			</div> -->
			
			<a-button @click="searchButton('button')" :loading="search_button_loading" class="screen-box" type="primary" icon="search">搜索</a-button>
			
			<a-button @click="goGiftLog" class="screen-box" type="primary" >赠送记录</a-button>
		</div>
	</div>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell-sticky" style="display: flex;align-items: center;">
					<template v-for="(item,index) in rableTitle" name="item.type">
						<div v-if="index <= sticky_index" class="table-th-cell" style="cursor: default;"
						:style="{'width':rableTitle[index].width + 'px'}" >
							{{rableTitle[index].title}}
						</div>
					</template>
				</div>
			</div>
			<div v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > sticky_index" class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type]}}
					</div>
				</template>
			</div>
			
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.type != 'province' && z_tem.type != 'user_agent' && z_tem.type != 'match_type' && z_tem.type != 'has_report' && z_tem.type != 'cz'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'province'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.province}} {{item.city}} {{item.county}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'user_agent'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<a-popover placement="top">
						<template slot="content">
						  <p style="width: 320px;">{{item[z_tem.type]}}</p>
						</template>
						<div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;height: 39px;">
							{{item[z_tem.type]}}
						</div>
					</a-popover>
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'match_type'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] | matchTypeFilter}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'has_report'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] | hasReportFilter}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'cz'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}" 
				style="display:flex;">
					<div @click="tdHandle(item,1)" style="color: #62a8ea;cursor: pointer;margin-right:12px;">赠送书币</div>
					<div @click="tdHandle(item,2)" style="color: #62a8ea;cursor: pointer;">赠送记录</div>
					<!-- <div v-show="item.has_report == 0" @click="HcTdTable(item,0)" style="color: #62a8ea;cursor: pointer;">手动回传</div> -->					<!-- <div v-show="item.has_report == '否' && !item.plan_id" @click="HcTdTable(item,1)" style="color: #62a8ea;cursor: pointer;">自定义回传</div> -->
				</div>
			</template>
		</div>
		
		<!-- 表格内容为空时显示 -->
		<tableNull :tableShowData="tableShowData" :table_null_width="table_null_width"></tableNull>
		
		<!-- 分页 -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	</div>
	
	<!-- 手动回传 -->
	<a-modal :visible="hc_visible" title="确认要回传？" @ok="hcOk" @cancel="hcCancel" 
	cancelText="取消" okText="确认" :confirmLoading="hc_confirm_loading">
	    <div>ID：{{hc_id}}</div>
	</a-modal>
	
	<!-- 自定义回传 -->
	<a-modal :visible="hc_Zdy_visible" title="自定义回传" @ok="hcZdyOk" @cancel="hcZdyCancel"
	cancelText="取消" okText="确认" :confirmLoading="hc_Zdy_loading">
		<div class="form-cell-box">
			<div class="class-title">落地页用户类型</div>
			<a-select
				:value="h_report_id_type"
			    style="width: 290px"
			    placeholder="请选择"
			    @change="handleChangeH"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
				<a-select-option value="0">自建落地页</a-select-option>
				<a-select-option value="1">基木鱼</a-select-option>
				<a-select-option value="3">巨量点击检测</a-select-option>
			</a-select>
		</div>
		
	    <div class="form-cell-box">
	    	<div class="class-title">落地页用户ID</div>
	    	<a-input v-model="h_report_id" placeholder="前往对应落地页用户类型页面复制ID" style="width: 290px;"  />
	    </div>
	</a-modal>
	
	<!-- 赠送书币弹框 -->
	<a-modal :visible="currency_visible" title="赠送书币" @ok="currencyOk" @cancel="currencyCancel"
	cancelText="取消" okText="确认" :confirmLoading="currency_loading">
		<div class="form-cell-box">
			<div class="class-title">用户ID</div>
			<div>{{c_show_id}}</div>
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">用户openid</div>
			<div>{{c_user_id}}</div>
		</div>
		
	    <div class="form-cell-box">
	    	<div class="class-title">赠送书币数量</div>
			<a-input-number id="inputNumber" v-model="currency_coin" :min="0" style="width:160px;" />
		</div>
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { putDataMenu, zsyGiftList,  orderGzhCustomReport, regGzhReport, otherCurrency } from '@/request/api'
export default {
	name: 'giftCurrency_',
	components: {},
	data() {
		return {
			startTime: '2020-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			filterList: { // 搜索条件内容
				channel_id: {},
				gzh_id: {},
			}, 
			gzhSelectData: [], // 某追书云渠道下的公众号选择
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				// {title:"ID", width:120, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"公众号", width:100, type:"gzh_name", },
				{title:"用户ID", width:120, type:"user_id", },
				// {title:"渠道", width:80, type:"channel_name", },
				{title:"用户OpenId", width:180, type:"openid", },
				{title:"注册时间", width:130, type:"reg_time", },
				
				// {title:"用户注册IP", width:130, type:"user_ip", },
				// {title:"IP地址", width:130, type:"province", },
				// {title:"UA", width:220, type:"user_agent", },
				
				// {title:"落地页", width:100, type:"report_id_type", },
				// {title:"落地页ID", width:100, type:"put_link_id", },
				// {title:"媒体平台", width:100, type:"report_platform", },
				// {title:"计划ID(单元ID)", width:150, type:"plan_id", },
				// {title:"创意ID", width:120, type:"creative_id", },
				// {title:"匹配指标", width:120, type:"match_type", },
				// {title:"是否回传", width:100, type:"has_report", },
				// {title:"回传原因", width:120, type:"pass_reason", },
				// {title:"回传时间", width:150, type:"report_time", },
				
				{title:"操作", width:150, type:"cz", },
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			sticky_index: 3,
			search_button_loading: false, // 搜索按钮的加载状态
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			
			r_channel_id: 102, // 渠道id。赠送书币功能目前只有追书云渠道，追书云渠道ID：102
			r_gzh_id: undefined, // 公众号id
			r_report_platform: undefined, // 媒体平台
			r_has_report: undefined, // 是否回传
			r_openid: null, // Openid
			r_plan_id: null, // 计划ID(单元ID)
			r_creative_id: null, // 创意ID
			r_user_id: null, // 用户ID
			
			hc_id: "", // 手动回传id
			hc_visible: false, // 手动回传弹窗
			hc_confirm_loading: false, 
			hc_Zdy_visible: false, 
			hc_Zdy_loading: false,
			h_report_id: "", // 落地页用户ID
			h_report_id_type: undefined, // 落地页用户类型
			
			date_number: 7, // x天前的日期
			
			// 赠送书币弹框
			currency_visible: false,
			currency_loading: false,
			currency_coin: 0, // 赠送的书币数量
			c_id: null,
			c_user_id: null,
			c_show_id: null, // 第三方用户ID，用于展示
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		that.table_null_width = table_info.null_width
		
		
		setTimeout(()=>{
			// 给母页面的tab传递粘性定位用的参数
			that.$bus.$emit("stickyData", that.table_scroll_width);
		},300)
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		// 获取当天日期
		this.endTime = this.$getThisDay()
		// 获取7天前的日期
		this.startTime = this.$getBeforeDay(this.date_number)
		
		
		putDataMenu().then(res=>{
			console.log('putDataMenu',res)
			that.filterList = res.data.data.filter
			
			that.is_admin = res.data.data.is_admin
			let g_data = []
			// 把追书云的公众号筛选出来
			res.data.data.filter.gzh_id.list.forEach(res=>{
				if(res.value.indexOf("追书云") > -1){
					g_data.push(res)
				}
			})
			that.gzhSelectData = g_data
		})
		
		// 搜索
		that.searchButton()
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onGetDate(date_start, date_end) {
			this.startTime = date_start
			this.endTime = date_end
		},
		handleChangeA(e){ // 渠道/书城
			console.log(e);
			this.r_channel_id = e
		},
		handleChangeB(e){ // 公众号
			console.log(e);
			this.r_gzh_id = e
		},
		handleChangeC(e){ // 是否回传
			console.log(e);
			this.r_has_report = e
			
		},
		handleChangeD(e){ // 媒体平台
			console.log(e);
			this.r_report_platform = e
		},
		
		handleChangeH(e){ // 落地页用户类型
			this.h_report_id_type = e
		},
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
			}
			
			zsyGiftList({
				// export: 0,
				limit: that.r_limit,
				page: that.r_page,
				start_date: that.startTime.replace(/-/g, ''),
				end_date: that.endTime.replace(/-/g, ''),
				channel_id: that.r_channel_id, // 渠道id
				gzh_id: that.r_gzh_id, // 公众号id
				has_report: that.r_has_report, // 是否回传
				report_platform: that.r_report_platform, // 媒体平台
				openid: that.r_openid, // Openid
				plan_id: that.r_plan_id, // 计划ID(单元ID)
				creative_id: that.r_creative_id, // 创意ID
				
				user_id: that.r_user_id, // 用户ID
			}).then(res=>{
				console.log('搜索',res);
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
			.catch(err=>{
				that.$message.error(`错误：${err}`);
				that.search_button_loading = false
			})
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// 回传操作
		HcTdTable(e,type){
			if(type == 0){ // 手动回传头条
				this.hc_id = e.id
				this.hc_visible = true
			}
			else if(type == 1){ // 自定义回传
				this.hc_id = e.id
				this.hc_Zdy_visible = true
				
			}
		},
		// 手动回传弹窗确认按钮
		hcOk(){
			let that = this
			that.hc_confirm_loading = true
			regGzhReport({
				id: that.hc_id
			}).then(res=>{
				console.log("回传",res);
				that.hc_confirm_loading = false
				
				if(res.data.code == 0){
					that.hcCancel()
					that.$message.success('操作成功');
					that.searchButton()
				}
				else {
					that.$message.error(res.data.msg || '操作失败');
				}
			})
			.catch(err=>{
				that.hc_confirm_loading = false
				console.log("err",err)
				that.$message.error("操作失败，可能是服务器出现问题");
			})
		},
		hcCancel(){
			if(this.hc_confirm_loading){
				return
			}
			this.hc_visible = false
		},
		// 自定义回传
		hcZdyOk(){
			let that = this
			if(!that.h_report_id_type){
				that.$message.warning('落地页用户类型不能为空');
				return
			}
			else if(!that.h_report_id){
				that.$message.warning('落地页用户ID不能为空');
				return
			}
			
			that.hc_Zdy_loading = true
			orderGzhCustomReport({
				order_id: that.hc_id,
				report_id: that.h_report_id,
				report_id_type: that.h_report_id_type,
			}).then(res=>{
				console.log("自定义回传",res);
				that.hc_Zdy_loading = false
				
				if(res.data.code == 0){
					that.hcZdyCancel()
					that.$message.success('操作成功');
					that.searchButton()
				}
				else {
					that.$message.error(res.data.msg || '操作失败');
				}
				
			})
			.catch(err=>{
				that.hc_Zdy_loading = false
				console.log("err",err)
				that.$message.error("操作失败，可能是服务器出现问题");
			})
		},
		hcZdyCancel(){
			if(this.hc_Zdy_loading){
				return
			}
			this.h_report_id = ""
			this.h_report_id_type = undefined
			this.hc_Zdy_visible = false
		},
		
		
		tdHandle(item,type){
			console.log("item,",item)
			if(type == 1){ // 赠送书币
				this.c_id = item.id
				this.c_user_id = item.openid
				this.c_show_id = item.user_id
				
				this.currency_visible = true
			}
			else if(type == 2){ // 操作记录
				const { href } = this.$router.resolve({ path:'/giftCurrencyLog', query:{chal_id: item.channel_id, gzh_id: item.gzh_id, user_id: item.user_id, openid: item.openid,}})
				window.open(href, '_blank');
			}
		},
		currencyOk(){
			let that = this
			if(that.currency_coin == 0){
				that.$message.warning('赠送书币数量不能为0');
				return
			}
			that.currency_loading = true
			otherCurrency({
				id: that.c_id,
				// id: "4308269",
				coin: that.currency_coin,
			}).then(res=>{
				that.currency_loading = false
				console.log("确认",res)
				
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.$message.success('操作成功');
					that.currencyCancel()
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		currencyCancel(){
			this.currency_visible = false
			this.currency_loading = false
			this.currency_coin = 0
		},
		
		goGiftLog(){
			const { href } = this.$router.resolve("/giftCurrencyLog")
			window.open(href, '_blank');
		}
	},
	filters: {
		matchTypeFilter(value){
			let mmm = ""
			if(value == 0){
				mmm = "未匹配"
			}
			else if(value == 1){
				mmm = "系统匹配"
			}
			else if(value == 2){
				mmm = "人工匹配"
			}
			else if(value == 3){
				mmm = "系统匹配：IP匹配"
			}
			else if(value == 4){
				mmm = "系统匹配：IP所在地匹配"
			}
			else if(value == 5){
				mmm = "系统匹配：设备ID匹配"
			}
			else if(value == 6){
				mmm = "用户注册表匹配"
			}
			return mmm
		},
		hasReportFilter(value){
			let mmm = ""
			if(value == 0){
				mmm = "不回传"
			}
			else if(value == 1){
				mmm = "已回传"
			}
			else if(value == -1){
				mmm = "未处理"
			}
			return mmm
		}
	}
}
</script>

<style scoped>
.class-title {
	width: 100px;
}

.table-td-cell {
	font-size: 13px;
}
</style>